export const SHOW_MOBILE_MENU_EVENT = 'show-header-mobile-menu';
export const CLOSE_DESKTOP_MENU_EVENT = 'close-header-desktop-menu';
